<div class="container py-4">

  <!-- 🔷 TÍTULO -->
 

  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/Banner IER.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar profesionales que desarrollen proyectos de generación, transformación, almacenamiento y gestión de energía proveniente de fuentes renovables; competentes en el diseño, implementación y evaluación de tecnologías limpias para el uso eficiente de la energía en el entorno nacional e internacional.
      </p>
    </div>

    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
       Formar profesionistas competitivos, capaces de resolver las necesidades energéticas mediante la investigación, desarrollo e implementación de las energías renovables que coadyuven a mejorar su entorno y el de la sociedad
      </p>
    </div>

     <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
      Ser el programa educativo que forme profesionistas capaces de solventar las necesidades energéticas de forma ética en un marco sustentable para beneficio de la sociedad de la región.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          1. Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditacion
        </button>
      </li>

    
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <P>
          El aspirante a ingresar al programa de Licenciatura en Ingeniería de Energías Renovables deberá contar con
        </P>
        <p>los siguientes conocimientos, habilidades, actitudes y valores.</p>

        <ul>
          <p>Conocimientos básicos en:</p>
          <li>Álgebra elemental</li>
          <li>Aritmética</li>
          <li>Trigonometría.</li>
          <li>Física.</li>
          <li>Química.</li>
          <li>Geografía.</li>
          <p>Habilidades:</p>
          <li>Capaz de identificar, analizar y resolver problemas</li>
          <li>Integrarse en equipos de trabajo con organización y disciplina</li>
          <li>Ser autodidacta y tener una buena comunicación oral y escrita.</li>
          <li>Ser promotor en el cuidado del medio ambiente</li>
          <p> Actitudes :</p>
          <li>Capaz de ser emprendedor, proactivo, y con un compromiso participativo</li>
          <li>Actitud positiva frente al reto de afrontar y resolver diversos problemas</li>
          <p> Valores: </p>
          <li>Respeto y aprecio por el medio ambiente</li>
          <li>Responsabilidad, honestidad y tolerancia</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">
        
        <ul>
          <li>Formula, evalúa y gestiona estrategias en proyectos de energía renovable con base a la normatividad vigente, para promover la eficiencia y la sustentabilidad energética.</li>
          <li>Diseña e implementa sistemas energéticos renovables para promover la competitividad de los sectores productivos.</li>
          <li>Analiza y evalúa la factibilidad de implementar procesos derivados de actividades de transformación y producción para el tratamiento de subproductos orgánicos</li>
          <li>Diseña, implementa y evalúa sistemas de generación eléctrica con fuentes alternativas para operar de forma aislada o interconectada a la red eléctrica.</li>
          <li>Aplica habilidades para establecer su propia empresa contribuyendo al desarrollo social, económico, tecnológico y ambiental de su entorno</li>
          <li>Diseña proyectos de investigación, desarrollo e innovación tecnológica, relacionados con la energía proveniente de fuentes renovables para optimizar los recursos energéticos</li>
          <li>Identifica y evalúa el recurso energético renovable disponible en el entorno para la producción de energía con calidad</li>
          <li>Contribuye al desarrollo de transferencia de tecnologías limpias a los sectores productivos para prevenir y mitigar los efectos del cambio climático</li>
        </ul>
      </div>

      <!-- TAB 3 -->
      <div id="tab3" class="tab-pane fade">
        <h4>Comité Mexicano de Acreditación de la Educación Agronómica, A.C. (29 enero 2021-28 enero 2026)</h4>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/Logo COMEAA.jpg" alt="Información de la carrera" class="tab-image">
        </div>
        
      </div>

    </div>
  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1VnEHoIHS3WmsKH2XwYeVm29kere5Jp4v" 
       target="_blank" 
       class="doc-link">
       ■ DOCUMENTACIÓN INGENIERÍA EN ENERGIAS RENOVABLES
    </a>
  </div>

  <hr>


  <div class="btn-section">

    <a href="assets/reticulas/Reticula IER.png" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- 👤 CONTACTO (AL FINAL 🔥) -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Dra. Laura Patricia Peña Yam</p>
        <p>E-mail: <a href="mailto:divisioniad@itsescarcega.edu.mx">divisioniad@itsescarcega.edu.mx</a></p>
        <P> Telefono:9991780878 </P>
      </div>

     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Ana Dalia Antonio Ordoñez</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9828291780</p>
      </div> 

    </div>

  </section>

</div>